import * as THREE from 'three';
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader';
import { MTLLoader } from 'three/examples/jsm/loaders/MTLLoader';
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';

export class ModelLoader {
  private static objLoader = new OBJLoader();
  private static fbxLoader = new FBXLoader();
  private static gltfLoader = new GLTFLoader();

  static async loadModel(path: string): Promise<THREE.Group | THREE.Object3D> {
    const fileExtension = path.split('.').pop()?.toLowerCase();

    return new Promise((resolve, reject) => {
      switch (fileExtension) {
        case 'obj':
          this.objLoader.load(
            path,
            (object) => resolve(object),
            (xhr) => {
              console.log((xhr.loaded / xhr.total * 100) + '% loaded');
            },
            (error) => reject(error)
          );
          break;

        case 'fbx':
          this.fbxLoader.load(
            path,
            (object) => resolve(object),
            (xhr) => {
              console.log((xhr.loaded / xhr.total * 100) + '% loaded');
            },
            (error) => reject(error)
          );
          break;

        case 'gltf':
        case 'glb':
          this.gltfLoader.load(
            path,
            (gltf) => resolve(gltf.scene),
            (xhr) => {
              console.log((xhr.loaded / xhr.total * 100) + '% loaded');
            },
            (error) => reject(error)
          );
          break;

        default:
          reject(new Error(`Unsupported file format: ${fileExtension}`));
      }
    });
  }

  // Rename this method to avoid the conflict
  // Đảm bảo phương thức này tồn tại
  static async loadModelWithMTL(objPath: string, mtlPath: string): Promise<THREE.Group> {
    return new Promise((resolve, reject) => {
      console.log(`Loading MTL from ${mtlPath}`);
      const mtlLoader = new MTLLoader();
      mtlLoader.load(
        mtlPath,
        (materials) => {
          materials.preload();
          console.log(`MTL loaded, now loading OBJ from ${objPath}`);
          
          const objLoader = new OBJLoader();
          objLoader.setMaterials(materials);
          objLoader.load(
            objPath,
            (object) => {
              console.log('OBJ loaded successfully');
              resolve(object);
            },
            (xhr) => {
              console.log((xhr.loaded / xhr.total * 100) + '% loaded');
            },
            (error) => {
              console.error('Error loading OBJ:', error);
              reject(error);
            }
          );
        },
        (xhr) => {
          console.log((xhr.loaded / xhr.total * 100) + '% MTL loaded');
        },
        (error) => {
          console.error('Error loading MTL:', error);
          reject(error);
        }
      );
    });
  }

  static async loadModelWithMaterial(objPath: string, material: THREE.Material): Promise<THREE.Group> {
    return new Promise((resolve, reject) => {
      const objLoader = new OBJLoader();
      objLoader.load(
        objPath,
        (object) => {
          object.traverse((child) => {
            if (child instanceof THREE.Mesh) {
              child.material = material;
            }
          });
          resolve(object);
        },
        undefined,
        (error) => {
          reject(error);
        }
      );
    });
  }
}